import { getEventHandler } from '../../utils';
export var getCardClickHandler = function getCardClickHandler(eventHandlers, url) {
  var handler = getEventHandler(eventHandlers, 'smartCard');
  return handler ? function (e) {
    return handler(e, url);
  } : undefined;
};